<template>
    <v-app app class="full-page-primary">
        <v-container class="fill-height text-center align justify" fluid style="width: 100%; height: 100%;">
            <v-row id="main-row-wrapper" class="fill-height ml-0" align="center" justify="center">
              <v-col cols="12" lg="3" sm="12">
                  <div>
                    <div class="text-center mb-4">
                        <img src="logo-no-adp.png" />
                    </div>
                    <v-alert :type="alert.type" v-if="alert.visible">{{alert.message}}</v-alert>
                    <v-form @submit.prevent="" ref="form" v-model="valid" v-if="alert.visible === false || alert.type === 'error'">
                        <v-text-field type="email" label="Email" v-model="email" :rules="emailRules" solo :disabled="loading" autocomplete="username" />

                        <v-btn type="submit" color="secondary" block large class="mb-3" @click="sendResetEmail()" :loading="loading">SEND PASSWORD RESET EMAIL</v-btn>
                    </v-form>
                    <v-btn :to="{ name: 'Login' }" :dark="!loading" block large :disabled="loading">BACK TO LOGIN</v-btn>

                </div>
              </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    export default {
        name: 'password-reset',
        data: () => ({
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            sent: false,
            email: '',
            loading: false,
            valid: true,
            alert: {
                type: 'success',
                message: '',
                visible: false
            }
        }),
        methods: {
            async sendResetEmail(){

                try {
                    this.loading = true
                    await this.$firebase.auth().sendPasswordResetEmail( this.email )
                    this.showAlert( 'success', 'Please check your email for a link to reset your password.')
                } catch (e){
                    this.showAlert( 'error', e.message )
                }

            },
            showAlert( type, msg ){
                this.alert.type = type
                this.alert.message = msg
                this.alert.visible = true
                this.loading = false
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>